import XHR from '../common/XHR';
import { addLoader, removeLoader, debounced, showMessage } from './Utils';

export default class {
    constructor() {
        this.handlers = {
            form: null
        };
        
        this.xhr = {
            url: "",
            method: ""
        };
        this.init();
    }

    init() {
        document.addEventListener('submit', e => {
            const target = e.target;
            if (target.getAttribute('data-xhr-form') !== null) {
                e.preventDefault();
                debounced(() => {
                    this.handlers.form = target;
                    addLoader(this.handlers.form);
                    this.prepareXHR();
                    this.prepareFormData();
                    this.sendForm();
                });
            }
        });
    }

    prepareXHR() {
        this.xhr.url = this.handlers.form.getAttribute('data-url');
        this.xhr.method = this.handlers.form.getAttribute('method') || "POST";
    }

    prepareFormData() {
        this.formData = new FormData(this.handlers.form);
    }

    sendForm() {
        const params = {
            url: this.xhr.url,
            method: this.xhr.method,
            data: this.formData,
            json: false,
            formData: true
        };
        XHR.send(params, response => {
            this.xhr.response = response;
            this.successCallback();
        }, response => {
            console.log('error', response);
        });
    }

    createMessage(message) {
        const messageNode = document.createElement('div');
        messageNode.classList.add('validate-message');
        messageNode.innerHTML = message;
        return messageNode;
    }

    removeErrors() {
        this.handlers.form.querySelectorAll('.field--error').forEach(element => {
            element.classList.remove('field--error');
            element.classList.remove('field--valid');
            const validateMessage = element.querySelector('.validate-message');
            if (validateMessage) {
                validateMessage.remove();
            }
        });

    }

    clearFields() {
        this.handlers.form.reset();
    }

    successCallback() {
        if (this.xhr.response) {
            const data = this.xhr.response;

            if (data.success) {
                this.removeErrors();
                this.clearFields();
            }

            if (typeof data.errors !== undefined && data.errors) {
                this.removeErrors();
                const errors = data.errors;
                Object.keys(errors).forEach(errorField => {
                    const field = this.handlers.form.querySelector(`[name="${errorField}"]`);
                    if (field) {
                        const fieldWrapper = field.closest('.field');
                        fieldWrapper.classList.add('field--error');
                        const message = this.createMessage(errors[errorField]);
                        fieldWrapper.appendChild(message);
                    }
                });
            }

            if (typeof data.alert !== "undefined" && data.alert) {
                const status = data.success ? "success" : "error";
                showMessage(status, data.alert);
            }
            
            removeLoader(this.handlers.form);
        }
            
        
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/common/Forms.js